(function () {
    'use strict';

    angular
        .module('app')
        .directive('article', article);

    article.$inject = ['$window'];

    function article($window) {
        // Usage:
        //     <article></article>
        // Creates:
        // 
        var directive = {
            link: link,
            scope: {
                articledata: '='
            },
            restrict: 'EA',
            templateUrl: "/static/Common/js/templates/article/_article.html"
        };
        return directive;

        function link($scope, $element, $attrs) {
           
        }
    }
})();


//////////////////
// WEBPACK FOOTER
// ./static/common/js/templates/article/_article.js
// module id = 17
// module chunks = 0